/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import {Link} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {KTSVG, toAbsoluteUrl} from '../../../helpers';
import {useLayout, usePageData} from '../../core';
import {Header} from './Header';
import {Navbar} from './Navbar';
import {useImpersonate} from '../../../../app/modules/auth/authorization/PermissionProvider';
import Button from 'react-bootstrap/Button';
import {useGetMe, useRemoveImpersonate} from '../../../../app/hooks/useGetMe';

export function HeaderWrapper() {
  const intl = useIntl();
  const {config, classes} = useLayout();
  const {pageTitle} = usePageData();
  const isImpersonate = useImpersonate();
  const {mutate} = useRemoveImpersonate();
  const customer = useGetMe();

  if (!config.app?.header?.display) {
    return null;
  }

  return (
    <div id="kt_app_header" className="app-header">
      <div
        id="kt_app_header_container"
        className={clsx(
          'app-container flex-xl-grow-1 w-100',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {isImpersonate && customer && (
          <div id="kt_app_header_wrapper" className="d-flex align-items-stretch flex-xl-grow-1">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {intl.formatMessage(
                {id: 'HEADER.IMPERSONATE.BANNER'},
                {impersonate: isImpersonate, customerId: customer.id, system: customer.system}
              )}
            </div>
            <Button style={{marginLeft: '10px'}} variant="danger" onClick={() => mutate()}>
              {intl.formatMessage({id: 'HEADER.IMPERSONATE.STOP'})}
            </Button>
          </div>
        )}

        {config.app.sidebar?.display && (
          <>
            <div
              className="d-flex align-items-center d-xl-none ms-n2 me-2"
              title="Show sidebar menu"
            >
              <div
                className="btn btn-icon btn-active-color-primary w-35px h-50px"
                id="kt_app_sidebar_mobile_toggle"
              >
                <KTSVG path="/media/icons/duotune/abstract/abs015.svg" className=" svg-icon-1" />
              </div>
              <div className="d-flex align-items-center flex-grow-1 flex-xl-grow-0">
                <Link to="/dashboard" className="d-xl-none">
                  <img
                    alt="Logo"
                    src="/media/logos/logo_etoile_celeste_bleu.png"
                    className="h-30px"
                  />
                </Link>
              </div>
            </div>
          </>
        )}

        {!config.app.sidebar?.display && (
          <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15">
            <Link to="/dashboard">
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt="Logo"
                  src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                  className="h-20px h-lg-30px app-sidebar-logo-default"
                />
              ) : (
                <>
                  <img
                    alt="Logo"
                    src={toAbsoluteUrl('/media/logos/default.svg')}
                    className="h-20px h-lg-30px app-sidebar-logo-default theme-light-show"
                  />
                  <img
                    alt="Logo"
                    src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                    className="h-20px h-lg-30px app-sidebar-logo-default theme-dark-show"
                  />
                </>
              )}
            </Link>
          </div>
        )}

        <div
          id="kt_app_header_wrapper"
          className="d-flex align-items-center justify-content-between flex-xl-grow-1"
        >
          {pageTitle && (
            <h1 className="text-celeste-primary fs-3 fw-bold my-0 ms-2">{pageTitle}</h1>
          )}
          <div className="d-flex align-items-stretch ms-auto">
            {config.app.header.default?.content === 'menu' &&
              config.app.header.default.menu?.display && (
                <div
                  className="app-header-menu app-header-mobile-drawer align-items-stretch"
                  data-kt-drawer="true"
                  data-kt-drawer-name="app-header-menu"
                  data-kt-drawer-activate="{default: true, lg: false}"
                  data-kt-drawer-overlay="true"
                  data-kt-drawer-width="225px"
                  data-kt-drawer-direction="end"
                  data-kt-drawer-toggle="#kt_app_header_menu_toggle"
                  data-kt-swapper="true"
                  data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                  data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
                >
                  <Header />
                </div>
              )}
            <Navbar />
          </div>
        </div>
      </div>
    </div>
  );
}
